import React from 'react';
import { ScrollView, RefreshControl, Text, FlatList } from 'react-native';
import RoutineCalenderCard from '../../components/Routines/RoutineDetails/RoutineCalenderCard';
import RoutineSummaryWidgetCard from '../../components/Routines/RoutineDetails/RoutineSummaryWidgetCard';
import RoutineActivity from './RoutineActivity';
import RoutineList from './RoutineList';
import UploadButtonWeb from '../../components/productRatings/UploadButtonWeb';
import ThankYouCard from '../../components/Routines/ThankYouCard';
import LeaderBoard from '../../components/Routines/LeaderBoard';
import CongratulationsCard from '../../components/Routines/CongratulationsCard';
import RoutineParticipationInfo from '../../components/Routines/RoutineParticipationInfo';
import CouponCodeCopyCard from '../../components/orders/actionCards/CouponCodeCopyCard';
import withRoutineDetails from './withRoutineDetails'; // Import the HOC
import { SCREEN_CONSTANTS } from '../../config/ScreenConstants';
import { ids, styles } from './Styles';
import { getScreenWidth } from '../../utils/LayoutUtility';
import { isPresent, isWeb } from '../../utils/BooleanUtility';
import RoutineScreenPlaceHolder, { RoutineActivityShimmer } from './RoutineScreenPlaceHolder';


const PostRoutine = ({
  isLoading,
  routineDaysData,
  selectedDay,
  selectedDayActivitiesData,
  itemData,
  myDailyRanks,
  phone,
  onChangeDay,
  setListRef,
  setActivityListRef,
  markRoutineActivityAsDone,
  showActivityToast,
  fileInputRef,
  handleFileChange,
  isRoutineActive,
  selectedDaySummaryCardContent = {},
  isSelectedDayLoading = false,
}) => {
  const renderOfferItem = ({ item }) => <CouponCodeCopyCard itemData={item} showToast={showActivityToast} />;

  const OfferRail = () => {
    const { offers = [] } = itemData;
    if (!offers.length) return null;
    return (
      <>
        <Text style={styles.offerRailHeading}>Offers you earned</Text>
        <FlatList data={offers} renderItem={renderOfferItem} contentContainerStyle={styles.offerFlatlist} />
      </>
    );
  };

  const renderPageContent = () => {
    if (isLoading) return <RoutineScreenPlaceHolder />;
    const {
      artist = {},
      myRewardPoints = '',
      slug = '',
      commonActivities = [],
      dailyPhotoes = [],
      selectedDayDateTime,
      leaderBoard = {},
      dailyLogins = '',
      participantCount = '',
      myRank,
      thankYouCard: { title: thankYouCardTitle = '', subtitle: thankYouCardSubTitle = '' } = {},
    } = itemData;
    const { name: artistName = '' } = artist;
    const tabListWidth = getScreenWidth() * 0.75;

    return (
      <>
        <ThankYouCard
          artistName={artistName}
          title={thankYouCardTitle}
          subTitle={thankYouCardSubTitle}
          isLoading={isLoading}
        />
        <RoutineCalenderCard
          numberOfDays={routineDaysData?.length || 0}
          selectedDay={selectedDay}
          onChangeDay={onChangeDay}
          isRoutineActive={isRoutineActive}
          setListRef={setListRef}
          routineDaysData={routineDaysData}
        />
        <RoutineSummaryWidgetCard summaryCardData={selectedDaySummaryCardContent} />
        {isSelectedDayLoading ? (
          <RoutineActivityShimmer />
        ) : (
          selectedDayActivitiesData?.map((item, index) => (
            <React.Fragment key={item?.id || `${selectedDay}-${index}`}>
              <RoutineActivity
                item={item}
                index={index}
                artist={artist}
                selectedDay={selectedDay}
                dailyPhotoes={dailyPhotoes}
                selectedDayActivitiesData={selectedDayActivitiesData}
                slug={slug}
                isRoutineActive={isRoutineActive}
                actionButtonPress={markRoutineActivityAsDone}
                selectedDayDateTime={selectedDayDateTime}
                showActivityToast={showActivityToast}
                tabListWidth={tabListWidth}
              />
              {isWeb() && <UploadButtonWeb fileInputRef={fileInputRef} handleFileChange={handleFileChange} />}
            </React.Fragment>
          ))
        )}
        {selectedDay === 0 && (
          <>
            {commonActivities.length > 0 && (
              <RoutineList itemData={commonActivities} myRewardPoints={myRewardPoints} isRoutineActive={false} />
            )}
            {isPresent(leaderBoard) && (
              <LeaderBoard leaderBoard={leaderBoard} myNumber={phone} myRank={myRank} myRewardPoints={myRewardPoints} />
            )}
            <OfferRail />
            <CongratulationsCard myDailyRanks={myDailyRanks} />
            <RoutineParticipationInfo dailyLogins={dailyLogins} participantCount={participantCount} />
          </>
        )}
      </>
    );
  };

  return (
    <ScrollView
      showsVerticalScrollIndicator={false}
      ref={setActivityListRef}
      refreshControl={<RefreshControl refreshing={isLoading} />}
    >
      {renderPageContent()}
    </ScrollView>
  );
};

export default withRoutineDetails(PostRoutine, SCREEN_CONSTANTS.POST_ROUTINE);
